import React from "react";
import Input from "../../../../components/FormComponents/Input";
import MultiSelectBox from "../../../../components/FormComponents/MultiSelectBox";
import { getLabelForKey } from "../../../../utils/Config/DefaultConfig/formFieldConfig";
import { ocrFormats } from "../../../../utils/Config/DefaultConfig/fileFormats";
import { AI_PROVIDER_LIST } from "../../../../constant/constant";
import Label from "../../../../components/FormComponents/Label";
import Button from "../../../../components/FormComponents/Button";
import Textarea from "../../../../components/FormComponents/Textarea";
import ButtonActionIcon from "../../../../components/BuilderComponents/ButtonActionIcon";
import SingleSelectBox from "../../../../components/FormComponents/SingleSelectBox";

const EditOcr = ({ editFieldData, setEditFieldData, fields }) => {
  const handleChangeInput = (name, value) => {
    setEditFieldData({ ...editFieldData, [name]: value });
  };

  const handleChangeValidationInput = (name, value) => {
    setEditFieldData({ ...editFieldData, validate: { ...editFieldData.validate, [name]: value } });
  };
  return (
    <div className="builder_form">
      <Input
        label={getLabelForKey("label")}
        value={editFieldData.label}
        name="label"
        onChange={({ target }) => handleChangeInput(target.name, target.value)}
      />
      <Input
        label={getLabelForKey("form_display_label")}
        value={editFieldData.form_display_label}
        name="form_display_label"
        onChange={({ target }) => handleChangeInput(target.name, target.value)}
      />
      <div className="field_horizontal_container">
        <SingleSelectBox
          options={[
            { name: "Default", value: "default" },
            { name: "Drag and Drop", value: "drag_and_drop" }
          ]}
          valueKey="value"
          labelKey={["name"]}
          selectedData={editFieldData?.layout_type || ""}
          onChange={(selected) => handleChangeInput("layout_type", selected?.value || "")}
          label="Select Layout"
          placeholder="Select Layout"
          isSearch
        />
      </div>
      <div className="flex_column gap_4 mt_1">
        <div className="field_horizontal_container">
          <Input
            type="checkbox"
            label={getLabelForKey("required")}
            checked={editFieldData.validate.required}
            name="required"
            onChange={({ target }) => handleChangeValidationInput(target.name, target.checked)}
            containerClassName="w_50"
          />
          <Input
            type="checkbox"
            label={getLabelForKey("disable")}
            checked={editFieldData.disable}
            name="disable"
            onChange={({ target }) => handleChangeInput(target.name, target.checked)}
            containerClassName="w_50"
          />
        </div>
        <div className="field_horizontal_container">
          <Input
            type="checkbox"
            label={getLabelForKey("from_camera")}
            checked={editFieldData.from_camera}
            name="from_camera"
            onChange={({ target }) => handleChangeInput(target.name, target.checked)}
            containerClassName="w_50"
          />
          <Input
            type="checkbox"
            label={getLabelForKey("backend_validation")}
            checked={editFieldData.validate.backend_validation}
            name="backend_validation"
            size="medium"
            containerClassName="w_50"
            onChange={({ target }) => handleChangeValidationInput(target.name, target.checked)}
          />
        </div>
        <div className="field_horizontal_container">
          <Input
            type="checkbox"
            label={getLabelForKey("mandatory")}
            checked={editFieldData.mandatory}
            name="mandatory"
            onChange={({ target }) => handleChangeInput(target.name, target.checked)}
            containerClassName="w_50"
          />
        </div>
        <div className="w_50 flex_column gap_2">
          <Label>Image Size</Label>
          <div className="flex_column gap_1 w_50">
            <Input
              type="number"
              value={editFieldData.fileMaxSize}
              name="fileMaxSize"
              onChange={({ target }) => handleChangeInput(target.name, target.value)}
            />
            <span>Max</span>
          </div>
        </div>
        <div className="field_horizontal_container">
          <Input
            label={getLabelForKey("help_text")}
            value={editFieldData.help_text}
            name="help_text"
            onChange={({ target }) => handleChangeInput(target.name, target.value)}
          />
        </div>
      </div>
      <div className="field_horizontal_container">
        <Input
          label={getLabelForKey("filePrefix")}
          value={editFieldData.filePrefix}
          name="filePrefix"
          onChange={({ target }) => handleChangeInput(target.name, target.value)}
        />
      </div>
      <div className="field_horizontal_container">
        <MultiSelectBox
          options={ocrFormats}
          valueKey="id"
          labelKey={["name"]}
          selectedData={editFieldData.acceptable_formats || []}
          onChange={(selected) => handleChangeInput("acceptable_formats", selected)}
          label="Acceptable Formats"
          placeholder="Select Formats"
          isSearch
        />
      </div>
      <Textarea
        value={editFieldData.description}
        label={getLabelForKey("description")}
        name="description"
        onChange={({ target }) => handleChangeInput(target.name, target.value)}
        placeholder="Enter description..."
        style={{ resize: "vertical" }}
      />
      <Label>AI Provider</Label>
      <select
        className="builder_input"
        value={editFieldData.ai_model}
        name="ai_model"
        onChange={({ target }) => handleChangeInput(target.name, target.value)}
      >
        {[...AI_PROVIDER_LIST, { id: "open-ai-custom", name: "Custom Open AI" }].map((item, index) => {
          return (
            <option key={index} value={item.id}>
              {item.name}
            </option>
          );
        })}
      </select>

      <OcrFieldMapping
        map={editFieldData.field_question_mapping}
        onChange={(mapping) => handleChangeInput("field_question_mapping", mapping)}
        fields={fields}
      />
    </div>
  );
};

const OcrFieldMapping = ({ map, onChange, fields }) => {
  const handleAddMapping = () => {
    onChange([...map, { question: "", field: "" }]);
  };

  const handleFieldDelete = (indexToDelete) => {
    const updatedMap = map.filter((_, index) => index !== indexToDelete);
    onChange(updatedMap);
  };

  return (
    <div>
      <div className={"d_flex justify_between align_center mb_3"} style={{ width: "100%" }}>
        <Label>Field Mapping</Label>
        <Button onClick={handleAddMapping}>Add</Button>
      </div>
      {map.map((item, index) => (
        <div key={index} className="builder_form border_full border_radius_medium mb_3 p_3 bg_light">
          <div className={"d_flex flex_column gap_2"}>
            <div className="d_flex justify_between w_100">
              <Label>Select Field</Label>
              <ButtonActionIcon type="delete" onClick={() => handleFieldDelete(index)} />
            </div>
            <select
              value={item.key}
              onChange={({ target }) =>
                onChange([...map.slice(0, index), { ...item, key: target.value }, ...map.slice(index + 1)])
              }
              className="builder_input"
            >
              <option value="">Select Field</option>
              {fields.map((field, i) => (
                <option key={i} value={field.id}>
                  {field.label}
                </option>
              ))}
            </select>
          </div>
          <div className={"d_flex flex_column gap_2"}>
            <Label>Question</Label>
            <Textarea
              type="text"
              value={item.question}
              onChange={({ target }) =>
                onChange([...map.slice(0, index), { ...item, question: target.value }, ...map.slice(index + 1)])
              }
              placeholder="Enter question..."
              style={{ resize: "vertical" }}
            />
          </div>
          <div className={"d_flex flex_column gap_2"}>
            <Label>Validation</Label>
            <Input
              value={item.validation}
              onChange={({ target }) =>
                onChange([...map.slice(0, index), { ...item, validation: target.value }, ...map.slice(index + 1)])
              }
              type="text"
              placeholder="Enter validation..."
            />
          </div>
        </div>
      ))}
    </div>
  );
};

export default EditOcr;
export { OcrFieldMapping };
